import { gql } from '@apollo/client'

export default gql`
  query Generic($slug: String!) {
    genericPage(slug: $slug) {
      slug
      title
      body
      seoDescription
      seoImage {
        url
      }
      seoTitle
    }
  }
`
